import React, { useEffect } from "react"
import { Form } from "antd"

import CustomInput from "../../../v2-components/Antd/Input"
import CustomSelect from "../../../v2-components/Antd/Select"
import CustomButton from "../../../v2-components/Antd/Button"

import { usePharmacyService } from "../hooks/usePharmacyService"

import { PLATFORMS, ROLES } from "../constants/index"

import "../styles/common.css"
import "../styles/forms.css"
import "../styles/button.css"


const AddUserForm = ({ onFinish, onCancel, loading = false }) => {
    const [form] = Form.useForm()
    const { getPharmacies } = usePharmacyService()
    const [pharmacies, setPharmacies] = React.useState([])

    useEffect(() => {
        const fetchPharmacies = async () => {
            try {
                const data = await getPharmacies()
                setPharmacies(data)
            } catch (error) {
                console.error("Error fetching pharmacies:", error)
            }
        }
        fetchPharmacies()
    }, [getPharmacies])

    // Manejar cancelación
    const handleCancel = () => {
        form.resetFields()
        if (onCancel) onCancel()
    }
    

    return (
        <div className="page-container">
            <Form form={form} layout="vertical" onFinish={onFinish} className="form-container">
                <h2 className="section-title">
                    Crear nuevo usuario
                </h2>

                {/* Correo electrónico */}
                <Form.Item
                    label="Correo electrónico"
                    name="email"
                    rules={[
                        { required: true, message: "Por favor ingresa un correo electrónico" },
                        { type: "email", message: "Por favor ingresa un correo electrónico válido" },
                    ]}
                    className="form-item"
                >
                    <CustomInput placeholder="Correo electrónico" />
                </Form.Item>

                {/* Primer nombre */}
                <Form.Item
                    label="Nombre de usuario"
                    name="first_name"
                    rules={[{ required: true, message: "Por favor ingresa el nombre de usuario" }]}
                    className="form-item"
                >
                    <CustomInput placeholder="Nombre" />
                </Form.Item>

                {/* Apellido */}
                <Form.Item
                    label="Apellido del usuario"
                    name="last_name"
                    rules={[{ required: true, message: "Por favor ingresa el apellido" }]}
                    className="form-item"
                >
                    <CustomInput placeholder="Apellido" />
                </Form.Item>

                {/* Contraseña */}
                <Form.Item
                    label="Contraseña"
                    name="password"
                    rules={[
                        { required: true, message: "La contraseña es obligatoria" },
                        { min: 8, message: "Debe tener al menos 8 caracteres" },
                    ]}
                    className="form-item"
                >
                    <CustomInput.Password />
                </Form.Item>

                <h2 className="section-title">
                    Rol
                </h2>

                {/* Roles - Cambiado a selección única */}
                <Form.Item
                    label="Rol de usuario"
                    name="roles"
                    rules={[{ required: true, message: "Por favor selecciona un rol" }]}
                    className="form-item"
                >
                    <CustomSelect placeholder="Selecciona un rol">
                        {ROLES.filter((option) => option.value !== "admin").map((option) => (
                            <CustomSelect.Option key={option.key} value={option.value}>
                                {option.label}
                            </CustomSelect.Option>
                        ))}
                    </CustomSelect>
                </Form.Item>

                <h2 className="section-title">Sucursal</h2>

                {/* Sucursales - Cambiado a selección única */}
                <Form.Item
                    label="Sucursal"
                    name="pharmacy"
                    rules={[{ required: true, message: "Por favor selecciona una sucursal" }]}
                    className="form-item"
                >
                    <CustomSelect placeholder="Selecciona una sucursal">
                        {pharmacies.map((pharmacy) => (
                            <CustomSelect.Option key={pharmacy.name} value={pharmacy.name}>
                                {pharmacy.label}
                            </CustomSelect.Option>
                        ))}
                    </CustomSelect>
                </Form.Item>

                        {/* Plataforma - Cambiado a selección única */}
                        <Form.Item
                    label="Plataforma"
                    name="platform"
                    rules={[{ required: true, message: "Por favor selecciona la plataforma" }]}
                    className="form-item"
                >
                    <CustomSelect placeholder="Selecciona la plataforma">
                        {PLATFORMS.map((platform) => (
                            <CustomSelect.Option key={platform.key} value={platform.value}>
                                {platform.key}
                            </CustomSelect.Option>
                        ))}
                    </CustomSelect>
                </Form.Item>

                {/* Botones de acción */}
                <div className="button-container">
                    <CustomButton className="plain-button" type="default" onClick={handleCancel} disabled={loading}>
                        Cancelar
                    </CustomButton>
                    <CustomButton className="filled-button" type="primary" onClick={() => form.submit()} loading={loading} disabled={loading}>
                        Guardar
                    </CustomButton>
                </div>
            </Form>
        </div>
    )
}

export default React.memo(AddUserForm)
